<template>
  <div>
    <div class="hidden-sm-and-down">
      <div class="d-flex justify-center">
        <img height="150" width="150" src="../../public/logo_f.png" />
      </div>
    </div>
    <div
      v-if="!showEmailConfirmed && !showPasswordResetSuccess"
      class="d-flex justify-center mt-3"
    >
      <h1 class="black--text">{{ welcomeMessage }}</h1>
    </div>
    <div v-if="showEmailConfirmed" class="d-flex justify-center mt-3">
      <v-alert type="info"> Your email has been confirmed!</v-alert>
    </div>
    <div v-if="showPasswordResetSuccess" class="d-flex justify-center mt-3">
      <v-alert type="info">
        Password changed successfully, please log in with your new
        password.</v-alert
      >
    </div>
    <div v-if="showEmailError" class="d-flex justify-center mt-3">
      <v-alert dense outlined text type="error">
        Couldn't confirm your email, please try again. If problem persists
        please contact
        <a>support</a></v-alert
      >
    </div>
    <div v-if="showSessionExpiredMsg" class="d-flex justify-center mt-3">
      <v-alert dense outlined text type="error" class="ma-0">
        Your session has expired, please log in again.
      </v-alert>
    </div>
    <v-card class="mx-auto my-4" max-width="450">
      <v-card-title>
        <p>Login</p>
      </v-card-title>
      <v-card-text>
        <v-form @submit.prevent="login">
          <v-text-field
            v-model="email"
            label="Email"
            type="email"
            required
          ></v-text-field>
          <v-text-field
            v-model="password"
            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
            :type="show ? 'text' : 'password'"
            name="input-10-2"
            label="Password"
            class="input-group--focused"
            @click:append="show = !show"
          >
          </v-text-field>
          <div class="d-flex justify-center mb-2 mt-2">
            <v-btn
              block
              large
              color="primary"
              :loading="btnLoading"
              :disabled="btnLoading"
              type="submit"
              >Login</v-btn
            >
          </div>
          <span class="red--text ma-0 sa-0">{{ errorMsg }}</span>
          <div class="d-flex justify-space-between mt-4">
            <div>
              <span>No account?</span>
              <a
                href="/register"
                class="text-decoration-none font-weight-medium"
              >
                Sign Up here
              </a>
            </div>
            <div>
              <a
                :href="'/password-reset?email=' + email"
                class="text-decoration-none font-weight-medium"
              >
                Forgot password?
              </a>
            </div>
          </div>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showEmailConfirmed: false,
      showPasswordResetSuccess: false,
      showEmailError: false,
      showSessionExpiredMsg: false,
      show: false,
      email: "",
      password: "",
      user: "",
      jwt: "",
      errorMsg: "",
      btnLoading: false,
      path: "", // Used to redirect after login
      welcomeMessage: this.getRandomWelcomeMessage(),
    };
  },
  methods: {
    async login() {
      if (!this.email || !this.password) {
        this.errorMsg = "Please enter both email and password";
        return;
      }
      try {
        this.btnLoading = true;
        this.errorMsg = "";
        var resp = await this.$utils.callBackendPost(this, "/pub/login", {
          username: this.email,
          password: this.password,
        });
        console.log("login got resp: " + JSON.stringify(resp, null, 2));
        if (resp.jwt) {
          this.$store.commit("setToken", resp.jwt);
        }
        if (resp.user) {
          this.$store.commit("setUser", resp.user);
        }
        if (resp.roles) {
          this.$store.commit("setRoles", resp.roles);
        }
        if (resp.isPro) {
          this.$store.commit("setIsPro", resp.isPro);
        }
        if (this.path) {
          this.$router.push(this.path);
        } else {
          this.$router.push("/");
        }
      } catch (error) {
        this.errorMsg = error;
      } finally {
        this.btnLoading = false;
      }
    },

    getRandomWelcomeMessage() {
      if (this.showSessionExpiredMsg) {
        return "Please login again";
      }
      const welcomeMessages = [
        "Welcome back!",
        "Hello there!",
        "Nice to see you again!",
        "Glad you're here!",
        "Hey, you're back!",
      ];
      const randomIndex = Math.floor(Math.random() * welcomeMessages.length);
      return welcomeMessages[randomIndex];
    },
  },
  mounted() {
    this.$utils.visit(this);
    console.log("msg:" + this.$route.query.msg);
    console.log("path:" + this.$route.query.path);
    this.path = this.$route.query.path;
    if (this.$route.query.msg == "ok") {
      this.showEmailConfirmed = true;
      this.$utils.trackEvent("sign_up", { method: "email" });
    } else if (this.$route.query.msg == "error") {
      this.showEmailError = true;
    } else if (this.$route.query.msg == "sessionExpired") {
      this.showSessionExpiredMsg = true;
    } else if (this.$route.query.msg == "passwordResetSuccess") {
      this.showPasswordResetSuccess = true;
    }
  },
};
</script>

<style></style>
